import { render } from "./ProjectChart.vue?vue&type=template&id=3381c520"
import script from "./ProjectChart.vue?vue&type=script&lang=js"
export * from "./ProjectChart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__